'use client'

import type { ReactNode } from 'react'

import { OnboardingRedirectGate } from '@/auth/OnboardingRedirectGate'
import { ProfileOnboardingGate } from '@/auth/ProfileOnboardingGate'
import { Layout } from '@/components/layout/Layout'
import { AddProfileDialogHost } from '@/components/views/accountManagement/profileOnboarding/AddProfileDialogHost'
import { OutletProvider } from '@/routing'

/**
 * Marketing/public shell rendering `<Layout />` (header, footer, mobile nav).
 * The page arrives as `children`; `OutletProvider` feeds it to the `<Outlet />`
 * inside `Layout` (see `src/routing/outlet.tsx`).
 */
export default function MarketingLayout({ children }: { children: ReactNode }) {
  return (
    <OutletProvider value={children}>
      <Layout />
      <OnboardingRedirectGate />
      <ProfileOnboardingGate />
      <AddProfileDialogHost />
    </OutletProvider>
  )
}
